// Module
var code = "<div class=\"widget-content relative\" style=\"overflow-x:hidden\"> <div ui-codemirror=\"{ onLoad : vm.codemirrorLoaded }\" ui-codemirror-opts=\"vm.codeMirrorOptions\" ng-model=\"vm.model\" style=\"width:100%\"></div> </div>";
// Exports
module.exports = code;